"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

var schema_name_generator_1 = require("@8base/schema-name-generator");

var selectors_1 = require("../selectors");

var graphql_prettier_1 = __importDefault(require("graphql-prettier"));

var errors_1 = require("../errors");

var createQueryString_1 = require("./createQueryString");

var upperFirst = function upperFirst(str) {
  return R.toUpper(R.head(str)) + R.tail(str);
};

var wrapInAppName = function wrapInAppName(appName, appContentName) {
  return function (queryString) {
    if (!appName) {
      return queryString;
    }

    return "\n    ".concat(appContentName ? "".concat(appContentName, ": ") : '').concat(appName, " {\n      ").concat(queryString, "\n    }");
  };
};

var getTable = function getTable(tablesList, tableId) {
  var table = selectors_1.tablesListSelectors.getTableById(tablesList, tableId);

  if (!table) {
    throw new errors_1.SDKError(errors_1.ERROR_CODES.TABLE_NOT_FOUND, errors_1.PACKAGES.UTILS, "Table schema with ".concat(tableId, " id not found."));
  }

  return table;
};

exports.createTableFilterGraphqlTag = function (tablesList, tableId) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var table = getTable(tablesList, tableId);
  var appName = selectors_1.tablesListSelectors.getTableApplicationName(tablesList, tableId);

  var _config$withResultDat = config.withResultData,
      withResultData = _config$withResultDat === void 0 ? true : _config$withResultDat,
      restConfig = __rest(config, ["withResultData"]);

  return graphql_prettier_1.default("\n  query ".concat(upperFirst(table.name), "TableContent(\n    $filter: ").concat(schema_name_generator_1.SchemaNameGenerator.getFilterInputTypeName(table.name, appName), "\n    $orderBy: [").concat(schema_name_generator_1.SchemaNameGenerator.getOrderByInputTypeName(table.name, appName), "]\n    $sort: [").concat(schema_name_generator_1.SchemaNameGenerator.getSortInputTypeName(table.name, appName), "!]\n    $after: String\n    $before: String\n    $first: Int\n    $last: Int\n    $skip: Int\n  ) {\n  ").concat(wrapInAppName(appName, config.appContentName)("\n  ".concat(config.tableContentName ? "".concat(config.tableContentName, ": ") : '').concat(schema_name_generator_1.SchemaNameGenerator.getTableListFieldName(table.name), "(\n      filter: $filter\n      orderBy: $orderBy\n      sort: $sort\n      after: $after\n      before: $before\n      first: $first\n      last: $last\n      skip: $skip\n    ) {\n      items {\n        id\n        ").concat(withResultData ? createQueryString_1.createQueryString(tablesList, table.id, Object.assign({}, restConfig)) : '', "\n        _description\n      }\n      count\n    }")), "\n  }"));
};

exports.createTableRowCreateTag = function (tablesList, tableId) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var table = getTable(tablesList, tableId);
  var appName = selectors_1.tablesListSelectors.getTableApplicationName(tablesList, tableId);
  var hasCreatableFields = R.pipe(R.propOr([], 'fields'), R.any(R.pathEq(['dataFeatures', 'create'], true)))(table);

  var _config$withResultDat2 = config.withResultData,
      withResultData = _config$withResultDat2 === void 0 ? true : _config$withResultDat2,
      restConfig = __rest(config, ["withResultData"]);

  if (hasCreatableFields) {
    return graphql_prettier_1.default("\n  mutation ".concat(upperFirst(table.name), "Create($data: ").concat(schema_name_generator_1.SchemaNameGenerator.getCreateInputName(table.name, appName), "!) {\n    ").concat(wrapInAppName(appName)("\n    ".concat(schema_name_generator_1.SchemaNameGenerator.getCreateItemFieldName(table.name), "(data: $data) {\n        id\n        ").concat(withResultData ? createQueryString_1.createQueryString(tablesList, tableId, Object.assign({
      withMeta: false
    }, restConfig)) : '', "\n        _description\n      }")), "\n    }"));
  }

  return graphql_prettier_1.default("\n  mutation ".concat(upperFirst(table.name), "Create {\n  ").concat(wrapInAppName(appName)("\n    ".concat(schema_name_generator_1.SchemaNameGenerator.getCreateItemFieldName(table.name), " {\n        id\n        ").concat(withResultData ? createQueryString_1.createQueryString(tablesList, tableId, Object.assign({
    withMeta: false
  }, restConfig)) : '', "\n        _description\n      }")), "\n    }"));
};

exports.createTableRowCreateManyTag = function (tablesList, tableId) {
  var table = getTable(tablesList, tableId);
  var appName = selectors_1.tablesListSelectors.getTableApplicationName(tablesList, tableId);
  var hasCreatableFields = R.pipe(R.propOr([], 'fields'), R.any(R.pathEq(['dataFeatures', 'create'], true)))(table);

  if (hasCreatableFields) {
    return graphql_prettier_1.default("\n  mutation ".concat(upperFirst(table.name), "CreateMany($data: [").concat(schema_name_generator_1.SchemaNameGenerator.getCreateManyInputName(table.name, appName), "]!) {\n    ").concat(wrapInAppName(appName)("\n      ".concat(schema_name_generator_1.SchemaNameGenerator.getCreateManyItemFieldName(table.name), "(data: $data) {\n          count\n        }")), "\n      }"));
  }

  return "\n  mutation ".concat(upperFirst(table.name), "CreateMany {\n  ").concat(wrapInAppName(appName)("\n  ".concat(schema_name_generator_1.SchemaNameGenerator.getCreateManyItemFieldName(table.name), " {\n      count\n    }")), "\n  }");
};

exports.createTableRowUpdateTag = function (tablesList, tableId) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var table = getTable(tablesList, tableId);
  var appName = selectors_1.tablesListSelectors.getTableApplicationName(tablesList, tableId);

  var _config$withResultDat3 = config.withResultData,
      withResultData = _config$withResultDat3 === void 0 ? true : _config$withResultDat3,
      restConfig = __rest(config, ["withResultData"]);

  return graphql_prettier_1.default("\n    mutation ".concat(upperFirst(table.name), "Update(\n      $data: ").concat(schema_name_generator_1.SchemaNameGenerator.getUpdateInputName(table.name, appName), "!, \n      $filter: ").concat(schema_name_generator_1.SchemaNameGenerator.getKeyFilterInputTypeName(table.name, appName), "\n    ) {\n    ").concat(wrapInAppName(appName)("\n      ".concat(schema_name_generator_1.SchemaNameGenerator.getUpdateItemFieldName(table.name), "(data: $data, filter: $filter) {\n          id\n          ").concat(withResultData ? createQueryString_1.createQueryString(tablesList, tableId, Object.assign({
    withMeta: false
  }, restConfig)) : '', "\n          _description\n        }")), "\n      }"));
};

exports.createTableRowQueryTag = function (tablesList, tableId) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var table = getTable(tablesList, tableId);
  var appName = selectors_1.tablesListSelectors.getTableApplicationName(tablesList, tableId);

  var _config$withResultDat4 = config.withResultData,
      withResultData = _config$withResultDat4 === void 0 ? true : _config$withResultDat4,
      restConfig = __rest(config, ["withResultData"]);

  return graphql_prettier_1.default("\n    query ".concat(upperFirst(table.name), "Entity($id: ID!) {\n    ").concat(wrapInAppName(appName)("\n      ".concat(schema_name_generator_1.SchemaNameGenerator.getTableItemFieldName(table.name), "(id: $id) {\n          id\n          ").concat(withResultData ? createQueryString_1.createQueryString(tablesList, tableId, Object.assign({}, restConfig)) : '', "\n          _description\n        }")), "\n      }"));
};

exports.createTableRowDeleteTag = function (tablesList, tableId) {
  var table = getTable(tablesList, tableId);
  var appName = selectors_1.tablesListSelectors.getTableApplicationName(tablesList, tableId);
  return graphql_prettier_1.default("\n    mutation ".concat(upperFirst(table.name), "Delete($filter: ").concat(schema_name_generator_1.SchemaNameGenerator.getKeyFilterInputTypeName(table.name, appName), "!, $force: Boolean) {\n    ").concat(wrapInAppName(appName)("\n      ".concat(schema_name_generator_1.SchemaNameGenerator.getDeleteItemFieldName(table.name), "(filter: $filter, force: $force) {\n          success\n        }")), "\n      }"));
};